module.exports = __parcel__import__.meta.resolve("fp56O");